import * as yup from 'yup';

export const GeneralInfoScheme = yup.object({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
});
